// extracted by mini-css-extract-plugin
module.exports = {"root":"colorFilter_root__RGWw4","item":"colorFilter_item__LQaSz","colorBlock":"colorFilter_colorBlock__WTHMS","activeItem":"colorFilter_activeItem__WBOi8 colorFilter_item__LQaSz"};